import { render } from "./ImportedHorseFormView.vue?vue&type=template&id=45169320&scoped=true"
import script from "./ImportedHorseFormView.vue?vue&type=script&lang=js"
export * from "./ImportedHorseFormView.vue?vue&type=script&lang=js"

import "./ImportedHorseFormView.vue?vue&type=style&index=0&id=45169320&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45169320"]])

export default __exports__